import { render, staticRenderFns } from "./JcomNationalBoardMembersEdit.vue?vue&type=template&id=8af00912"
import script from "./JcomNationalBoardMembersEdit.vue?vue&type=script&lang=js"
export * from "./JcomNationalBoardMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./JcomNationalBoardMembersEdit.vue?vue&type=style&index=0&id=8af00912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports